/*! @pentacode/ui v0.1.0 */
import { fieldOf as e } from "./table.util.js";
// src/elements/table/table-sort.ts
var t = class {
	constructor(e) {
		this.states = [], this._collator = new Intl.Collator(void 0, {
			numeric: !0,
			sensitivity: "base"
		}), this.host = e, e.addController(this);
	}
	hostConnected() {}
	hostDisconnected() {}
	setStates(e) {
		this.states = e;
	}
	getEntry(e) {
		let t = this.states.findIndex((t) => t.field === e);
		return t === -1 ? null : {
			state: this.states[t],
			index: t
		};
	}
	handleHeaderClick(t, n) {
		if (t.target.closest("button, ptc-ui-dropdown, ptc-ui-table-header-menu, wa-dropdown-item, .resize-handle")) return;
		let r = e(n), i = this.states.find((e) => e.field === r);
		this.states = t.shiftKey ? i ? i.direction === "asc" ? this.states.map((e) => e.field === r ? {
			...e,
			direction: "desc"
		} : e) : this.states.filter((e) => e.field !== r) : [...this.states, {
			field: r,
			direction: "asc"
		}] : i ? i.direction === "asc" ? [{
			field: r,
			direction: "desc"
		}] : [] : [{
			field: r,
			direction: "asc"
		}], this._emitChange(n, r), this.host.requestUpdate();
	}
	handleMenuSort(t, n) {
		let r = e(n), i = this.states.find((e) => e.field === r);
		this.states = i?.direction === t ? this.states.filter((e) => e.field !== r) : i ? this.states.map((e) => e.field === r ? {
			...e,
			direction: t
		} : e) : [{
			field: r,
			direction: t
		}], this._emitChange(n, r), this.host.requestUpdate();
	}
	getSortedData(e, t) {
		return this.states.length === 0 ? e : [...e].sort((e, n) => {
			for (let { field: r, direction: i } of this.states) {
				let a = t(e, r), o = t(n, r);
				if (a == null && o == null) continue;
				if (a == null) return 1;
				if (o == null) return -1;
				let s;
				if (s = typeof a == "number" && typeof o == "number" ? a - o : this._collator.compare(String(a), String(o)), s !== 0) return i === "desc" ? -s : s;
			}
			return 0;
		});
	}
	_emitChange(e, t) {
		this.host.dispatchEvent(new CustomEvent("ptc-ui-table-sort-change", {
			detail: {
				column: e,
				direction: this.states.find((e) => e.field === t)?.direction ?? null
			},
			bubbles: !0,
			composed: !0
		}));
	}
};
export { t as SortController };

//# sourceMappingURL=table-sort.js.map